/**
 * colorMap.js
 * Mapa centralizado de nombre de color → valor hexadecimal.
 * Usado por VariantSelector y cualquier componente que renderice swatches de color.
 *
 * Fallback: si el nombre no está en el mapa, usar '#CCCCCC'.
 */

export const COLOR_MAP = {
  // ── Negros / Oscuros ──────────────────────────────────────────────────
  "Negro": "#1a1a1a",
  "NEGRO": "#1a1a1a",
  "Negro Azulado": "#0d0d1a",
  "NEGRO AZULADO": "#0d0d1a",
  "Negro Intenso": "#000000",
  "NEGRO INTENSO": "#000000",
  "Negro Profundo": "#0A0A0A",
  "NEGRO PROFUNDO": "#0A0A0A",
  "Ebano": "#1C1C1C",
  "Ebano Negro": "#1C1C1C",
  "Moreno": "#2C1503",
  "MORENO": "#2C1503",
  "Moreno Intenso": "#1a0a00",
  "MORENO INTENSO": "#1a0a00",

  // ── Castaños ──────────────────────────────────────────────────────────
  "Castaño": "#4A2A0A",
  "CASTAÑO": "#4A2A0A",
  "Castano": "#4A2A0A",
  "Castaño Oscuro": "#3B1E08",
  "CASTAÑO OSCURO": "#3B1E08",
  "Castaño Oscuro Profundo": "#2A1205",
  "Espresso Castaño Oscuro": "#2C1503",
  "Castaño Natural": "#4A2A0A",
  "CASTAÑO NATURAL": "#4A2A0A",
  "Castaño Medio": "#4A2A0A",
  "CASTAÑO MEDIO": "#4A2A0A",
  "Castaño Claro": "#6B3A1F",
  "CASTAÑO CLARO": "#6B3A1F",
  "Castaña Cataño Claro": "#6B3A1F",
  "Castaño Claro Dorado": "#8B5E3C",
  "CASTAÑO CLARO DORADO": "#8B5E3C",
  "Castano Claro Dorado": "#8B5E3C",
  "Café Amaretto Castaño Claro Dorado": "#8B5E3C",
  "Castaño Claro Ceniza": "#6B5B52",
  "CASTAÑO CLARO CENIZA": "#6B5B52",
  "Castaño Claro Caoba": "#5A2D1A",
  "CASTAÑO CLARO CAOBA": "#5A2D1A",
  "CASTAÑO CLAO CAOBA": "#5A2D1A",
  "Castaño Claro Caoba Rojizo": "#5A2D1A",
  "CASTAÑO CLARO CAOBA ROJIZO": "#5A2D1A",
  "Castaño Claro Rojizo": "#9B2335",
  "CASTAÑO CLARO ROJIZO": "#9B2335",
  "Castaño Claro Rojizo Caoba": "#7A2A1A",
  "CASTAÑO CLARO ROJIZO CAOBA": "#7A2A1A",
  "Castaño Claro Rojizo Intenso": "#8B1C2A",
  "CASTAÑO CLARO ROJIZO INTENSO": "#8B1C2A",
  "Castaño Claro Cobrizo": "#B85D19",
  "CASTAÑO CLARO COBRIZO": "#B85D19",
  "Castaño Claro Ciruela": "#6B1F45",
  "CASTAÑO CLARO CIRUELA": "#6B1F45",
  "Castaño Claro Chocolate": "#4A2A14",
  "CASTAÑO CLARO CHOCOLATE": "#4A2A14",
  "Castaño Claro Ceniza Irisado": "#7A6A78",
  "CASTAÑO CLARO CENIZA IRISADO": "#7A6A78",
  "Castaño Ceniza": "#5A4A42",
  "CASTAÑO CENIZA": "#5A4A42",
  "Castaño Ceniza Caoba": "#5A3525",
  "Castano Ceniza Caoba": "#5A3525",
  "CASTAÑO CENIZA CAOBA": "#5A3525",
  "Castaño Rojizo": "#7B3B2A",
  "CASTAÑO ROJIZO": "#7B3B2A",
  "Castaño Rojizo Viola": "#7B2A55",
  "CASTAÑO ROJIZO VIOLA": "#7B2A55",
  "Castaño Cobrizo Dorado": "#B85D19",
  "CASTAÑO COBRIZO DORADO": "#B85D19",
  "Castaño Ciruela": "#6B1F45",
  "CASTAÑO CIRUELA": "#6B1F45",
  "Castaño Nogal": "#3B2008",
  "CASTAÑO NOGAL": "#3B2008",
  "Castaño Roble": "#4A2A0A",
  "CASTAÑO ROBLE": "#4A2A0A",
  "Castaño Chocolate": "#3D1C02",
  "CASTAÑO CHOCOLATE": "#3D1C02",
  "Castaño Café": "#2C1503",
  "CASTAÑO CAFÉ": "#2C1503",
  "Castano Rojizo": "#7B3B2A",

  // ── Chocolates ────────────────────────────────────────────────────────
  "Chocolate": "#3D1C02",
  "CHOCOLATE": "#3D1C02",
  "Chocolatisimo": "#2A1000",
  "Chocolate Puro": "#3D1C02",
  "CHOCOLATE PURO": "#3D1C02",
  "Chocolate Caoba": "#4A2416",
  "CHOCOLATE CAOBA": "#4A2416",
  "Chocholate Caoba": "#4A2416",
  "Chocolate Oscuro": "#2A1000",
  "CHOCOLATE OSCURO": "#2A1000",
  "Chocolate Claro": "#5D3520",
  "CHOCOLATE CLARO": "#5D3520",
  "Chocolate Dorado": "#5D3520",
  "CHOCOLATE DORADO": "#5D3520",
  "Chocolate Claro Dorado": "#6D4530",
  "CHOCOLATE CLARO DORADO": "#6D4530",
  "CHOCHOLATE": "#3D1C02",

  // ── Rubios ────────────────────────────────────────────────────────────
  "Rubio": "#C9A84C",
  "RUBIO": "#C9A84C",
  "Rubio Oscuro": "#C8A96E",
  "RUBIO OSCURO": "#8B6914",
  "Rubio Natural": "#E8C98A",
  "RUBIO NATURAL": "#E8C98A",
  "Rubio Claro": "#F5DEB3",
  "RUBIO CLARO": "#EAD090",
  "Rubio Muy Claro": "#F5E6C8",
  "RUBIO MUY CLARO": "#F5E6C8",
  "Rubio Ultra Claro": "#FFF5E0",
  "RUBIO ULTRA CLARO": "#FFF5E0",
  "Rubio Dorado": "#DAA520",
  "RUBIO DORADO": "#DAA520",
  "Rubio Ceniza": "#B0A080",
  "RUBIO CENIZA": "#B0A080",
  "Rubio Rojizo": "#A0522D",
  "RUBIO ROJIZO": "#A0522D",
  "Rubio Cobrizo": "#C87941",
  "RUBIO COBRIZO": "#C87941",
  "Rubio Oscuro Ceniza": "#9A8060",
  "RUBIO OSCURO CENIZA": "#9A8060",
  "Rubio Oscuro Dorado": "#A87828",
  "RUBIO OSCURO DORADO": "#A87828",
  "Rubio Oscuro Rojizo": "#9A4A2A",
  "RUBIO OSCURO ROJIZO": "#9A4A2A",
  "Rubio Oscuro Cobrizo": "#B06030",
  "RUBIO OSCURO COBRIZO": "#B06030",
  "Rubio Oscuro Chocolate": "#7A5030",
  "RUBIO OSCURO CHOCOLATE": "#7A5030",
  "Rubio Claro Ceniza": "#D4C5A9",
  "RUBIO CLARO CENIZA": "#D4C5A9",
  "Rubio Claro Dorado": "#D4AF37",
  "RUBIO CLARO DORADO": "#D4AF37",
  "Rubio Muy Claro Ceniza": "#E8DCC8",
  "RUBIO MUY CLARO CENIZA": "#E8DCC8",
  "Rubio Muy Claro Dorado": "#F0D878",
  "RUBIO MUY CLARO DORADO": "#F0D878",
  "Rubio Platinado": "#F0E6C8",
  "Rubio Profundo": "#A8780A",
  "RUBIO PROFUNDO": "#A8780A",
  "Rubio Extra Claro": "#FFF8E8",
  "RUBIO EXTRA CLARO": "#FFF8E8",
  "RUBIO EXTRA CLARO CENIZA": "#F0E8D0",
  "Rubio Ceniza Profundo": "#908070",
  "RUBIO CENIZA PROFUNDO": "#908070",
  "Rubio Claro Ceniza Irisado": "#D0C8C0",
  "RUBIO CLARO CENIZA IRISADO": "#D0C8C0",
  "Rubio Claro Irisado": "#D8D0B8",
  "RUBIO CLARO IRISADO": "#D8D0B8",
  "Rubio Oscuro Irisado": "#907840",
  "RUBIOOSCURO IRISADO": "#907840",
  "Rubio Oscuro Rojizo Intenso": "#8A3010",
  "RUBIO OSCURO ROJIZO INTENSO": "#8A3010",
  "Rubio Muy Claro Irisado": "#F0E8D8",
  "RUBIO MUY CLARO IRISADO": "#F0E8D8",
  "Rubio Medio": "#C0900A",
  "RUBIO MEDIO": "#C0900A",
  "Rubio Medio Ceniza": "#B09878",
  "RUBIO MEDIO CENIZA": "#B09878",
  "Rubio Medio Dorado": "#C8A020",
  "RUBIO MEDIO DORADO": "#C8A020",
  "Rubio Medio Beige": "#C8B090",
  "RUBIO MEDIO BEIGE": "#C8B090",
  "Rubio Medio Malva": "#B09098",
  "RUBIO MEDIO MALVA": "#B09098",
  "Rubio Medio Irisado": "#B8A068",
  "RUBIO MEDIO IRISADO": "#B8A068",
  "Rubio Claro Beige": "#EAD8B0",
  "RUBIO CLARO BEIGE": "#EAD8B0",
  "Rubio Claro Malva": "#D0B8C8",
  "RUBIO CLARO MALVA": "#D0B8C8",
  "Rubio Claro Rojizo Cobrizo": "#C87040",
  "RUBIO CLARO ROJIZO COBRIZO": "#C87040",
  "Rubio Claro Chocolate": "#C09060",
  "RUBIO CLARO CHOCOLATE": "#C09060",
  "Rubio Muy Claro Malva": "#E8D0D8",
  "RUBIO MUY CLARO MALVA": "#E8D0D8",
  "Rubio Muy Claro Beige": "#F0E0C8",
  "RUBIO MUY CLARO BEIGE": "#F0E0C8",
  "Rubio Dorado Cobrizo": "#C09020",
  "RUBIO DORADO COBRIZO": "#C09020",
  "Rubio Dorado Nacarado": "#D8B840",
  "RUBIO DORADO NACARADO": "#D8B840",
  "Rubio Ceniza Irisado": "#B8B098",
  "RUBIO CENIZA IRISADO": "#B8B098",
  "Rubio Ceniza Malva": "#B8A8B0",
  "RUBIO CENIZA MALVA": "#B8A8B0",
  "Rubio Ceniza Cobrizo": "#B8A078",
  "RUBIO CENIZA COBRIZO": "#B8A078",
  "Rubio Ceniza Beige Claro": "#C8C0A8",
  "RUBIO CENIZA BEIGE CLARO": "#C8C0A8",
  "Rubio Ceniza Dorado": "#C0A858",
  "RUBIO CENIZA DORADO": "#C0A858",
  "Rubio Ceniza Nacarado": "#C0B8A8",
  "Rubio Oscuro Beige Miel": "#B09050",
  "RUBIO OSCURO BEIGE MIEL": "#B09050",
  "Rubio Claro Ceniza Malva": "#D0C0C8",
  "RUBIO CLARO CENIZA MALVA": "#D0C0C8",
  "Rubio Claro Ceniza Dorado": "#D0C090",
  "RUBIO CLARO CENIZA DORADO": "#D0C090",
  "Rubio Claro Malva Ceniza": "#D0C0C8",
  "RUBIO CLARO MALVA CENIZA": "#D0C0C8",
  "Rubio Claro Dorado Profundo": "#C8A828",
  "RUBIO CLARO DORADO PROFUNDO": "#C8A828",
  "Rubio Muy Claro Ceniza Irisado": "#E0D8C8",
  "RUBIO MUY CLARO CENIZA IRISADO": "#E0D8C8",
  "Rubio Muy Claro Ceniza Malva": "#E0D0D8",
  "RUBIO MUY CLARO CENIZA MALVA": "#E0D0D8",
  "Rubio Muy Claro Malva Ceniza": "#E0D0D8",
  "RUBIO MUY CLARO MALVA CENIZA": "#E0D0D8",
  "Rubio Muy Claro Dorado Profundo": "#F0D848",
  "RUBIO MUY CLARO DORADO PROFUNDO": "#F0D848",
  "Rubio Muy Claro Dorado Cobrizo": "#F0C858",
  "RUBIO MUY CLARO DORADO COBRIZO": "#F0C858",
  "Rubio Super Claro Natural": "#FFF8F0",
  "RUBIO SUPER CLARO NATURAL": "#FFF8F0",
  "Rubio Super Claro Ceniza": "#F0EAE0",
  "RUBIO SUPER CLARO CENIZA": "#F0EAE0",
  "Rubio Super Claro Malva": "#F0E0E8",
  "RUBIO SUPER CLARO MALVA": "#F0E0E8",
  "Rubio Super Claro Dorado": "#FFF0C0",
  "RUBIO SUPER CLARO DORADO": "#FFF0C0",
  "Rubio Super Claro Malva Ceniza": "#F0E0E8",
  "RUBIO SUPER CLARO MALVA CENIZA": "#F0E0E8",
  "Rubio Glasé": "#E8D8C0",
  "RUBIO GLACE": "#E8D8C0",
  "Rubio Claro Glasé": "#F0E0C8",
  "RUBIO CLARO GLACE": "#F0E0C8",
  "Rubio Muy Claro Glasé": "#F8F0E0",
  "RUBIO MUY CLARO GLACE": "#F8F0E0",
  "Rubio Clarisimo": "#FFFBF0",
  "RUBIO CLARISIMO": "#FFFBF0",
  "Rubio Extra Blond": "#FFF8E8",
  "RUBIO EXTRA BLOND": "#FFF8E8",
  "Rubio Extra Blond Grey": "#F0EAE0",
  "RUBIO EXTRA BLOND GREY": "#F0EAE0",
  "Rubio Oro Muy Claro": "#FFF0C0",
  "RUBIO ORO MUY CLARO": "#FFF0C0",
  "Rubio Oscuro Ceniza Dorado": "#9A8840",
  "RUBIO OSCURO CENIZA DORADO": "#9A8840",
  "Rubio Oscuro Dorado Perlado": "#A89040",
  "RUBIO OSCURO DORADO PERLADO": "#A89040",
  "Rubio Oscuro Ceniza Irisado": "#9A9068",
  "RUBIO OSCURO CENIZA IRISADO": "#9A9068",
  "Rubio Oscuro Ceniza Cobrizo": "#9A7848",
  "RUBIO OSCURO CENIZA COBRIZO": "#9A7848",
  "Rubio Oscuro Cobrizo Caoba": "#9A5A30",
  "RUBIO OSCURO COBRIZO CAOBA": "#9A5A30",
  "Rubio Oscuro Caoba": "#9A4820",
  "RUBIO OSCURO CAOBA": "#9A4820",
  "Rubio Oscuro Cobrizo Dorado": "#A86828",
  "RUBIO OSCURO COBRIZO DORADO": "#A86828",
  "Rubio Oscuro Cobre Rojizo Brillante": "#C06820",
  "RUBIO OSCURO COBRE ROJIZO BRILLANTE": "#C06820",
  "Rubio Oscuro Glasé": "#908058",
  "RUBIO OSCURO GLACE": "#908058",
  "Rubio Oscuro Caoba Rojizo": "#8A3818",
  "RUBIO OSCURO CAOBA ROJIZO": "#8A3818",
  "Rubio Oscuro Rojizo Profundo": "#8A2808",
  "Rubio Oscuro Chocolate Ceniza": "#907060",
  "RUBIO OSCURO CHOCOLATE CENIZA": "#907060",
  "Rubio Chocolate Ceniza": "#A08060",
  "RUBIO CHOCOLATE CENIZA": "#A08060",
  "Rubio Claro Ceniza Nacarado": "#D8D0B8",
  "RUBIO CLARO CENIZA NACARADO": "#D8D0B8",
  "Rubio Claro Dorado Menta": "#D8D078",
  "RUBIO CLARO DORADO MENTA": "#D8D078",
  "Rubio Claro Beige Calido": "#E0CCA0",
  "RUBIO CLARO BEIGE CALIDO": "#E0CCA0",
  "Rubio Claro Beige Miel": "#E0C890",
  "RUBIO CLARO BEIGE MIEL": "#E0C890",
  "Rubio Claro Marron Dorado": "#C0A050",
  "RUBIO CLARO MARRON DORADO": "#C0A050",
  "Rubio Claro Oro Cobrizo": "#D0A030",
  "RUBIO CLARO ORO COBRIZO": "#D0A030",
  "Rubio Claro Chocolate Dorado": "#C09840",
  "RUBIO CLARO CHOCOLATE DORADO": "#C09840",
  "Rubio Claro Chocolate Ceniza": "#C09870",
  "RUBIO CLARO CHOCOLATE CENIZA": "#C09870",
  "Rubio Muy Claro Ceniza Dorado": "#F0E088",
  "RUBIO MUY CLARO CENIZA DORADO": "#F0E088",
  "Rubio Muy Claro Dorado Menta": "#F0E878",
  "RUBIO MUY CLARO DORADO MENTA": "#F0E878",
  "Rubio Muy Claro Beige Calido": "#F0DEC0",
  "RUBIO MUY CLARO BEIGE CALIDO": "#F0DEC0",
  "Rubio Muy Claro Dorado Salvaje": "#F8E040",
  "RUBIO MUY CLARO DORADO SALVAJE": "#F8E040",
  "Rubio Muy Claro Ceniza Nacarado": "#F0E8D8",
  "RUBIO MUY CLARO CENIZA NACARADO": "#F0E8D8",
  "Rubio Muy Claro Oro": "#F8E898",
  "RUBIO MUY CLARO ORO": "#F8E898",
  "Rubio Dorado Miel": "#D0A818",
  "RUBIO DORADO MIEL": "#D0A818",
  "Rubio Dorado Avellana": "#C09838",
  "RUBIO DORADO AVELLANA": "#C09838",
  "Rubio Dorado Nacarado": "#D8B850",
  "Rubio Claro Natural": "#EAD8A0",
  "RUBIO CLARO NATURAL": "#EAD8A0",
  "Rubio Claro Oro": "#D4B820",
  "RUBIO CLARO ORO": "#D4B820",
  "Rubio Medio Beige Calido": "#C8AE80",
  "RUBIO MEDIO BEIGE CALIDO": "#C8AE80",
  "Rubio Medio Rojizo Intenso": "#B86030",
  "RUBIO MEDIO ROJIZO INTENSO": "#B86030",
  "Rubio Medio Beige Miel": "#C8A868",
  "RUBIO MEDIO BEIGE MIEL": "#C8A868",
  "Rubio Medio Maroon Dorado": "#B89038",
  "RUBIO MEDIO MAROON DORADO": "#B89038",
  "Rubio Muy Claro Glace": "#F8F0E0",
  "RUBIOO COBRE ZANAHORIA": "#D06820",
  "RUBIOO CHOCOLATE DORADO": "#C09030",
  "RUBIOO CLARO CENIZA": "#D0C8A0",
  "RUBIOO MUY CLARO": "#F8F0E8",
  "RUBIO OSCUROS CENIZA": "#9A9070",
  "RUBIO COBRECO ZANAHORIA": "#D06820",
  "RUBIO CENIC NACARADO": "#C0B8A8",
  "RUBIO DORDADO NACARADO": "#D8B840",
  "RUBIO CLAROCL CENIZA": "#D4C8A0",
  "RUBIO CLARO CLARO CENIZA": "#D8D0B0",
  "RUBIO CLARO CLARO CENIZA IRISADO": "#D8D0C0",
  "Rubio Oscuro Dorado Irisado": "#A89858",
  "RUBIO OSCURO DORADO PERLADO": "#A89040",
  "RUBIO ROJIZO PROFUNDO": "#9A3010",
  "Rubio Muy Claro Ceniza Dorado": "#F0E098",
  "MARACUYA RUBIO ULTRA CLARO CENIZA DORADO": "#F5E888",
  "AZAHAR RUBIO EXTRA CLARO CENIZA": "#F0EAD0",

  // ── Rojizos / Cobrizos ────────────────────────────────────────────────
  "Rojo": "#CC0000",
  "Rojo Intenso": "#8B0000",
  "ROJO INTENSO": "#8B0000",
  "Rojo Cobrizo": "#CB6D3A",
  "ROJO COBRIZO": "#CB6D3A",
  "Rojo Brillante": "#FF1A1A",
  "ROJO BRILLANTE": "#FF1A1A",
  "Rojo Granate": "#722F37",
  "ROJO GRANATE": "#722F37",
  "Rojo Ciruela": "#8B1A4A",
  "ROJO CIRUELA": "#8B1A4A",
  "Rojo Carmin": "#990033",
  "ROJO CARMIN": "#990033",
  "Rojo Extremo": "#CC0000",
  "ROJO EXTREMO": "#CC0000",
  "Rojo Profundo": "#8B0000",
  "ROJO PROFUNDO": "#8B0000",
  "Rojo Intenso Nacarado": "#9B1A2A",
  "ROJO INTENSO NACARADO": "#9B1A2A",
  "Rojo Claro Perlado": "#D06070",
  "ROJO CLARO PERLADO": "#D06070",
  "Bordo": "#5C0A0A",
  "Bordo Oscuro": "#3E0102",
  "Borgoña": "#800020",
  "Borgonya": "#800020",
  "Borgoña Claro": "#A02040",
  "BORGOÑA CLARO": "#A02040",
  "Borgoña Castaño Rojizo": "#800020",
  "Rojizo": "#9B2335",
  "Cobrizo": "#CB6D3A",
  "Cobrizo Rubi": "#9B2335",
  "Caoba": "#722F37",
  "CAOBA": "#5A2010",
  "Cereza Exotico": "#8B0000",
  "CEREZA EXOTICO": "#8B0000",
  "Grosella": "#8B0040",
  "Grosella Negra": "#5A0020",

  // ── Aclarantes ────────────────────────────────────────────────────────
  "ACLARANTE": "#E8D898",
  "ACLARANTE PLATA": "#C8C8C0",
  "ACLARANTE CENIZA PLATINO": "#B8C0C8",
  "ACLARANTE DORADO": "#E0C840",
  "ACLARANTE MALVA": "#C8A8C8",
  "ACLARANTE MALVA CENIZA": "#C0A8C0",
  "SUPER ACLARANTE NATURAL": "#F8F0D8",
  "SUPER ACLARANTE CENIZA": "#E8E0D0",
  "SUPER ACLARANTE MALVA": "#F0D8E0",
  "Platino": "#D8D8E0",
  "PLATINO": "#D8D8E0",

  // ── Grises ────────────────────────────────────────────────────────────
  "Gris": "#808080",
  "Gris Claro": "#D3D3D3",
  "Gris Oscuro": "#404040",
  "Gris Plata": "#A8B0B8",
  "GRIS PLATA": "#A8B0B8",
  "Gris Humo": "#606870",
  "GRIS HUMO": "#606870",
  "Gris Acero": "#607080",
  "GRIS ACERO": "#607080",
  "GRIS OSCURO": "#404040",
  "Ceniza": "#A0A0A0",
  "CENIZA OSCURO INTENSO": "#808080",
  "CENIZA INTENSO": "#909090",
  "CENIZA CLARO INTENSO": "#C0C0C0",
  "CENIZA MUY CLARO INTENSO": "#D8D8D8",
  "TABACO OSCURO": "#4A3010",
  "TABACO MEDIANO": "#6A5020",
  "TABACO CLARO": "#8A7040",
  "MARRON OSCURO": "#5A2808",
  "MARRON MEDIO": "#7A4A20",
  "MARRON MORISCO": "#6A3818",
  "MARRON ESPAÑOL": "#7A4028",

  // ── Tonos cálidos / neutros ───────────────────────────────────────────
  "Miel": "#FFC30B",
  "Avellana": "#855E42",
  "Caramelo": "#C68642",
  "Champana": "#F7E7CE",
  "Champaña Rubio": "#F7E7CE",
  "Almendra": "#EFDECD",
  "Almendra Rubio Ceniza": "#D4C5A9",
  "Jazmin": "#F5F0E8",
  "Jazmin Rubio Muy Claro Ceniza": "#F5F0E8",
  "Margarita": "#FFFACD",
  "Margarita Rubio Muy Claro Dorado": "#FFFACD",
  "Nectar": "#FFBE00",
  "Nectar Rubio Claro": "#FFBE00",
  "Trigo": "#F5DEB3",
  "Trigo Rubio Muy Claro": "#F5DEB3",
  "Centeno": "#8B7355",
  "Centeno Rubio Oscuro Ceniza": "#9A8060",
  "Ambar": "#FFBF00",
  "Ambar Castaño Claro Dorado Caoba": "#8B5020",
  "Azahar": "#F0E5CE",
  "Maracuya": "#F5C518",
  "Capuccino": "#6F4E37",
  "Capuccino Rubio Oscuro": "#C8A96E",
  "Espresso": "#2C1503",
  "Cafe": "#4A2F1C",
  "Café Castaño": "#4A2F1C",
  "Tamarindo": "#6B3226",

  // ── Colores vivos ─────────────────────────────────────────────────────
  "Rosa": "#FFB6C1",
  "Rosa Claro": "#FFCDD2",
  "Rosa Oscuro": "#C2185B",
  "Fucsia": "#FF0090",
  "Coral": "#FF6B6B",
  "Durazno": "#FFCBA4",
  "Nude": "#D4A574",
  "Lavanda": "#E6E6FA",
  "Lila": "#C8A2C8",
  "Violeta": "#8B00FF",
  "Morado": "#6A0DAD",
  "Arandano": "#5D2D91",
  "Azul": "#0055AA",
  "Turquesa": "#40E0D0",
  "Verde": "#228B22",
  "Verde Oliva": "#808000",

  // ── Neutros / especiales ──────────────────────────────────────────────
  "Beige": "#F5F5DC",
  "Arena": "#C2B280",
  "Marfil": "#FFFFF0",
  "Porcelana": "#F7E7CE",
  "Blanco": "#FFFFFF",
  "Blanco Perla": "#F8F8F0",
  "Dorado": "#FFD700",
  "Plateado": "#C0C0C0",
  "Bronce": "#CD7F32",
  "Dorado Cobrizo": "#B8860B",
  "Transparente": "#E8E8E8",
  "Incoloro": "#F5F5F5",
  "Tostado Natural": "#9A6A30",
  "TOSTADO NATURAL": "#9A6A30",
};

/**
 * Obtiene el hex de un color por su nombre.
 * @param {string} nombre - Nombre del color (puede ser con mayúsculas, tildes, etc.)
 * @returns {string} Valor hex o '#CCCCCC' como fallback
 */
export function getColorHex(nombre) {
  if (!nombre) return '#CCCCCC';
  return COLOR_MAP[nombre] || COLOR_MAP[nombre.toUpperCase()] || '#CCCCCC';
}
